import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

/**
 * Nøkkeltall til operatørdashbordets modulkort (Teamwork 36340292).
 * Null = tallet kunne ikke hentes — kortet vises da uten tall.
 */
export interface OperatorDashboardCountersDto {
  receiptOpen: number | null;
  putAwayTotal: number | null;
  putAwayMine: number | null;
  pickingTotal: number | null;
  pickingMine: number | null;
  packingTotal: number | null;
  packingReady: number | null;
  countingTotal: number | null;
  countingMine: number | null;
}

export const operatorDashboardService = {
  async getCounters(warehouseId?: string, dueTodayOnly?: boolean): Promise<OperatorDashboardCountersDto> {
    const params = new URLSearchParams();
    if (warehouseId) params.append('warehouseId', warehouseId);
    if (dueTodayOnly) params.append('dueTodayOnly', 'true');

    const query = params.toString();
    const response = await AuthService.authenticatedGet(
      `${API_BASE_URL}/operator-dashboard/counters${query ? `?${query}` : ''}`
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch dashboard counters: ${response.statusText}`);
    }

    return response.json();
  }
};
